module.exports = __webpack_public_path__ + "img/5.e13e1600.jpg";